import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { appConfig } from '../config';

/**
 * Access-denied screen shown when a signed-in identity is NOT the single permitted user.
 * The unauthorized attempt is logged and the user is signed out automatically.
 */
export function AccessDenied({ attemptedUser }: { attemptedUser?: string }): JSX.Element {
  const { instance } = useMsal();

  useEffect(() => {
    console.warn('Unauthorized access attempt', { attemptedUser: attemptedUser ?? 'unknown' });
    const timer = window.setTimeout(() => {
      void instance.logoutRedirect();
    }, 4000);
    return () => window.clearTimeout(timer);
  }, [instance, attemptedUser]);

  return (
    <div className="flex min-h-screen items-center justify-center p-6" role="alert">
      <div className="max-w-md rounded-lg border border-red-500 bg-kore-card p-8 text-center">
        <h1 className="text-xl font-semibold text-red-400">Unauthorized Access</h1>
        <p className="mt-3 text-sm text-slate-300">This application is restricted.</p>
        <p className="mt-2 text-xs text-slate-500">
          Only {appConfig.allowedUser} may access KoreID Bank Settlement Control. You will be
          signed out automatically.
        </p>
        <button
          type="button"
          onClick={() => void instance.logoutRedirect()}
          className="mt-6 rounded bg-red-600 px-4 py-2 text-sm text-white hover:opacity-90"
        >
          Sign out now
        </button>
      </div>
    </div>
  );
}
